import NavBarView from "./NavBarView";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useScrollTrigger } from "@mui/material";

const NavBarController = () => {
  const navigate = useNavigate();
  const [navgationMenuOpen, setNavgationMenuOpen] = useState(false);
  const isScrolling = useScrollTrigger({
    threshold: 0,
    target: document.getElementById("root") || undefined,
  });

  const onLogoClick = () => {
    navigate("/");
  };

  const onNavigationMenuClick = () => {
    setNavgationMenuOpen(!navgationMenuOpen);
  };

  const onBackdropClick = () => {
    setNavgationMenuOpen(false);
  };

  return (
    <NavBarView
      navgationMenuOpen={navgationMenuOpen}
      onNavigationMenuClick={onNavigationMenuClick}
      onBackdropClick={onBackdropClick}
      onLogoClick={onLogoClick}
      isScrolling={isScrolling}
    />
  );
};

export default NavBarController;
